import React from "react";
import { DataTable } from "@/components/DataTable";
import { Button } from "@/components/ui";
import { useTranslation } from "react-i18next";
import { BulkMessage } from "@/__generated__/graphql";
import { Row } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/routes/paths";

export const SentBulkMessageActions = ({
  row,
}: {
  row: Row<BulkMessage | null>;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = row.original || {};

  return (
    <DataTable.TBodyCell isLastCell={true}>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          onClick={() =>
            navigate(`${id}/${ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.DETAILS}`)
          }
        >
          {t("bulkMessaging.table.tableActions")}
        </Button>
      </div>
    </DataTable.TBodyCell>
  );
};
